import axios from "axios";
import { URL } from "../../../constants/provider/constant";
import { platform } from "./constants";

export const fetchOrders = async (
  services,
  sourcePage,
  subPage,
  startDate,
  endDate,
  page,
  searchDetails,
  isExport = false,
  sortByField = "FulfillmentDate",
  sortDirection = "asc"
) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    let data = {
      userId: userDetails.userId,
      services: services,
      sourcePage: sourcePage,
      subPage: subPage,
      providerId: userDetails.providerId ? userDetails.providerId : userDetails.corporateIDs[0],
      fetchForProviders: userDetails.selectedProviders ? userDetails.selectedProviders.map((id) => parseInt(id)) : [],
      startDate: startDate,
      endDate: endDate,
      priority: 0,
      rows: 10,
      pageNumber: page,
      sortByField: sortByField,
      isDescending: sortDirection == "desc" ? true : false,
      isSearch: searchDetails ? true : false,
      fetchHighSLACases: false,
    };

    if (searchDetails) {
      switch (searchDetails.Name) {
        case "Request Id":
          data.searchParam = { requestIds: searchDetails.Id.map((id) => parseInt(id)) };
          break;
        case "Employee Id":
          data.searchParam = { employeeIds: searchDetails.Id.map((id) => id) };
          break;
        case "Name":
          data.searchParam = { patientName: searchDetails.Id[0] };
          break;
        case "Phone Number":
          data.searchParam = { contactNumber: searchDetails.Id[0] };
          break;
        case "Email":
          data.searchParam = { emailId: searchDetails.Id[0] };
          break;
        default:
          data.searchParam = null;
          break;
      }
    }

    let config = {
      method: "post",
      url: isExport ? URL.providercore_url + "medibuddyCentral/ExportRequestDetails" : URL.providercore_url + "medibuddyCentral/RequestDetails",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json, text/plain, */*",
      },
      data: data,
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    if(err?.response?.status == 403) {
      localStorage.setItem("tokenExpired", "true")
    }
    console.log(err);
  }
};

export const availableDoctors = async (requestId) => {
  try {
    let config = {
      method: "get",
      url: `${URL.consults_backend}doctor/available-for-reschedule?requestId=${requestId}&allowPriceChange=false`,
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const updateRequests = async (services, requestIds, remarks, action, scheduledAppointmentDate = null, doctorId = null, attachFiles = null, feedback = null, slotDistributionForDate = null, slotDistributionForInterval = null) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    let requestData;
    let data = {
      userId: userDetails.userId,
      services: services,
      providerId: userDetails.providerId,
      requestUpdateData: [],
    };
    for (const requestId of requestIds) {
      requestData = {
        requestId: requestId,
        remarks: remarks,
        action: action,
      };
      if (scheduledAppointmentDate) {
        requestData.scheduledAppointmentDate = scheduledAppointmentDate;
      }
      if (doctorId) {
        requestData.doctorId = doctorId;
      }
      if (attachFiles) {
        requestData.attachFiles = attachFiles;
      }
      if(feedback) {
        requestData.userFeedback = feedback;
      }
      if(slotDistributionForDate) {
        requestData.slotDistributionForDate = slotDistributionForDate;
      }
      if(slotDistributionForInterval) {
        requestData.slotDistributionForInterval = slotDistributionForInterval;
      }
      data.requestUpdateData.push(requestData);
    }

    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/updateRequests",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json",
      },
      data: data,
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err?.response?.data?.error);
    throw err;
  }
};

export const uploadFile = async (payload) => {
  try {
    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/uploadFile",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const fetchAdditionalInfo = async (services, requestIds) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    let data = {
      userId: userDetails.userId,
      providerId: userDetails.providerId,
      services: services,
      requestIds: requestIds,
      properties: []
    }
    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/fetchAdditionalDetails",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json",
      },
      data: data,
    };
    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const download = (data, fileName) => {
  const blob = new Blob([data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", fileName + ".csv");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const getProvidersCalendar = async (data) => {
  try {
    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/getProvidersCalendar",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json",
        platform: platform,
      },
      data: data,
    };
    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
